module.exports = __webpack_public_path__ + "img/vip4.3c650136.png";